import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 lg:py-32 relative">
      <div className="relative max-w-screen-xl mx-auto px-6 lg:px-8">
        <div className="modern-card text-center py-16 px-8">
          {/* Main Heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-6 leading-tight">
            Ready to Dominate <span className="gradient-text">Shakespeare?</span>
          </h2>

          <p className="text-lg sm:text-xl text-white/80 mb-8 max-w-3xl mx-auto">
            Join thousands of students who are crushing their English classes with BardPlay. Start your free journey today!
          </p>

          <button
            onClick={() => navigate('/registration')}
            className="btn-primary text-lg px-12 py-5 inline-flex items-center justify-center gap-3 hover:scale-105 transition-transform duration-300"
          >
            <Icon name="Rocket" size={24} />
            Start Your Journey
          </button>

          <p className="text-white/60 text-sm mt-8">
            No credit card required • Join 10,000+ students • Free forever
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;